import { css } from '@emotion/react';
export const spaceX = size => /*#__PURE__*/css({
  '& > * + *': {
    marginLeft: size
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:spaceX;");
export const spaceY = size => /*#__PURE__*/css({
  '& > * + *': {
    marginTop: size
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:spaceY;");